import { useMemo } from 'react';
import { useNotifications } from 'shared/layout/notification-stack/data/NotificationAPI';
import { useSubscriptionDetails } from './SubscriptionAPI';

export function useSubscriptionTrialCountdown({
  isEnabled = true,
}: {
  isEnabled?: boolean;
} = {}) {
  const { data: notifications } = useNotifications({
    enabled: isEnabled,
  });

  const { data: subscriptionDetails } = useSubscriptionDetails({
    enabled: isEnabled,
  });

  const trialDaysLeft = useMemo(() => {
    const notification = notifications?.find(
      ({ notification_type }) => notification_type === 'trial_countdown',
    );

    if (notification?.notification_type !== 'trial_countdown') return null;

    return notification.context.days_left;
  }, [notifications]);

  const isSubscriptionInTrial =
    subscriptionDetails?.subscription?.status === 'in_trial';

  return {
    isSubscriptionInTrial,
    subscriptionDetails,
    trialDaysLeft,
  };
}
